var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 34,
    viewBox: "0 0 169 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0L20.6637 11.6603L32.9241 11.6603L23.0052 18.8668L26.7939 30.5272L16.875 23.3207L6.95612 30.5272L10.7448 18.8668L0.825922 11.6603L13.0863 11.6603L16.875 0Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 0L54.4137 11.6603L66.6741 11.6603L56.7552 18.8668L60.5439 30.5272L50.625 23.3207L40.7061 30.5272L44.4948 18.8668L34.5759 11.6603L46.8363 11.6603L50.625 0Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.375 0L88.1637 11.6603L100.424 11.6603L90.5052 18.8668L94.2939 30.5272L84.375 23.3207L74.4561 30.5272L78.2448 18.8668L68.3259 11.6603L80.5863 11.6603L84.375 0Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.125 0L121.914 11.6603L134.174 11.6603L124.255 18.8668L128.044 30.5272L118.125 23.3207L108.206 30.5272L111.995 18.8668L102.076 11.6603L114.336 11.6603L118.125 0Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.875 0L155.664 11.6603L167.924 11.6603L158.005 18.8668L161.794 30.5272L151.875 23.3207L141.956 30.5272L145.745 18.8668L135.826 11.6603L148.086 11.6603L151.875 0Z",
    fill: "#909090"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars5);
export default __webpack_public_path__ + "static/media/stars_5.fcb92ff5db64592f7533de49bb7ebea8.svg";
export { ForwardRef as ReactComponent };